import { useRef, useState } from 'react';

interface IProps {
  intervalDuration: number;
  onFinishCountdown: () => void;
}

export const useCountdownTimer = ({ intervalDuration, onFinishCountdown }: IProps) => {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const timerId = useRef<ReturnType<typeof setInterval> | null>(null);
  const loadTimeStamp = useRef<number | null>(null);
  const didFinishCounting = useRef<boolean>(false);

  function startTimer(timestamp?: number) {
    timestamp = timestamp || Date.now();
    loadTimeStamp.current = timestamp!;
    didFinishCounting.current = false;
    const initialElapsedTimeInSeconds = (Date.now() - loadTimeStamp.current) / 1000;
    setTimeLeft(Number((intervalDuration - initialElapsedTimeInSeconds).toFixed(0)));

    timerId.current = setInterval(() => {
      if (didFinishCounting.current || !loadTimeStamp.current) {
        return;
      }
      const elapsedTimeInSeconds = (Date.now() - loadTimeStamp.current) / 1000;
      setTimeLeft(Number((intervalDuration - elapsedTimeInSeconds).toFixed(0)));

      if (Math.max(intervalDuration - elapsedTimeInSeconds, 0) === 0) {
        onFinishCountdown();
        setTimeLeft(null);
        if (timerId.current) clearInterval(timerId.current);
        didFinishCounting.current = true;
        loadTimeStamp.current = null;
      }
    }, 1000);
  }

  return { startTimer, timeLeft };
};
